// **************************************************
import { Injectable } from '@angular/core';
import {
  CalenderNameViewModel,
  DatePickerModel,
  MonthViewModel,
  PersianDateViewModel,
  WeekViewModel,
} from '../models/calender-models/calender-model';
import * as Setting from '../../assets/settings.json';
// **************************************************

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor() {}

  public setting: any = Setting;

  public monthClassNames: string[] = [
    'january', //دی
    'february', //بهمن
    'march', //اسفند

    'april', //فروردین
    'may', //اردیبهشت
    'june', //خرداد

    'july', //تیر
    'august', //مرداد
    'september', //شهریور

    'october', //مهر
    'november', //آبان
    'december', //آذر
  ];

  public getYear(yearNumber: number): MonthViewModel[] {
    const months: MonthViewModel[] = [];
    try {
      for (let i = 0; i < 12; i++) {
        months.push(new MonthViewModel(i + 1, this.GetMonthName(i)));
      }
    } catch (Exception) {}
    return months;
  }

  public GetMonth(monthNumber: number, yearNumber: number): WeekViewModel[] {
    try {
      const startDate = this.toDateTime(`${yearNumber}/${monthNumber}/1`);
      const startDateOfWeek = this.getFirstShowDate(startDate);
      const persianMonthNumber = monthNumber;

      const weeks: WeekViewModel[] = [];
      let date = startDateOfWeek;

      let curretMonth = 0;
      let curretDay = 0;
      for (let i = 0; i < 6; i++) {
        const week = new WeekViewModel();

        for (let j = 0; j < 7; j++) {
          const thisDay: PersianDateViewModel = this.ToPersianDateTime(
            date.toString()
          );
          curretMonth = thisDay.month;
          curretDay = thisDay.day;
          thisDay.name = this.GetWeekDayName(thisDay.dayOfWeek);

          week.days.push(thisDay);
          date = new Date(date.getTime() + 24 * 60 * 60 * 1000); // Adding one day
        }

        weeks.push(week);

        if (curretMonth != persianMonthNumber) break;
        if (curretMonth == persianMonthNumber && curretDay == 31) break;
      }

      return weeks;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  private toDateTime(persianDate: string): Date {
    if (!persianDate || persianDate.trim() === '') return new Date();

    const match = persianDate.match(
      /^(?<year>1[0,1,2,3,4,5]\d{2})[\/,-](?<month>[0,1]{0,1}\d)[\/,-](?<day>[0,1,2,3]{0,1}\d)/
    );
    if (match == null) return new Date();

    if (match.groups == null) return new Date();

    return this.ToGregorianDateTime(persianDate);
  }

  public ToPersianDateTime(dateTime: string): PersianDateViewModel {
    const thisDate = new Date(dateTime);
    var shamsi = require('shamsi-date-converter');
    var jalaliDate = shamsi.gregorianToJalali(dateTime);
    return new PersianDateViewModel(
      jalaliDate[2],
      thisDate.getDay(),
      jalaliDate[1],
      jalaliDate[0],
      thisDate
    );
  }

  public ToGregorianDateTime(dateTime: string): Date {
    let dayRegexp = new RegExp(
      /^(?<year>\d{4})(-|\/)(?<month>\d{1,2})(-|\/)(?<day>\d{1,2})/
    );

    if (!dayRegexp.test(dateTime)) {
      return new Date();
    }

    let groups = dateTime.match(dayRegexp)?.groups;
    let year: number = Number(groups?.['year']);
    let month: number = Number(groups?.['month']);
    let day: number = Number(groups?.['day']);

    var shamsi = require('shamsi-date-converter');
    var gregorianDate = shamsi.jalaliToGregorian(year, month, day);
    const thisDate = new Date(
      gregorianDate[0],
      gregorianDate[1] - 1,
      gregorianDate[2]
    );

    return thisDate;
  }

  private getFirstShowDate(date: Date): Date {
    let result = new Date(date);
    switch (date.getDay()) {
      case 0:
        result.setDate(result.getDate() - 1);
        break;
      case 1:
        result.setDate(result.getDate() - 2);
        break;
      case 2:
        result.setDate(result.getDate() - 3);
        break;
      case 3:
        result.setDate(result.getDate() - 4);
        break;
      case 4:
        result.setDate(result.getDate() - 5);
        break;
      case 5:
        result.setDate(result.getDate() - 6);
        break;
      case 6:
        break;
      default:
        break;
    }

    return result;
  }

  private getLastShowDate(date: Date): Date {
    let result = new Date(date);
    switch (date.getDay()) {
      case 0:
        result.setDate(result.getDate() + 5);
        break;
      case 1:
        result.setDate(result.getDate() + 4);
        break;
      case 2:
        result.setDate(result.getDate() + 3);
        break;
      case 3:
        result.setDate(result.getDate() + 2);
        break;
      case 4:
        result.setDate(result.getDate() + 1);
        break;
      case 5:
        break;
      case 6:
        result.setDate(result.getDate() + 6);
        break;
      default:
        break;
    }

    return result;
  }

  public GetWeekDayName(dayOfWeek: number): CalenderNameViewModel {
    switch (dayOfWeek) {
      case 0:
        return new CalenderNameViewModel('Saturday', 'Sa', 'شنبه', 'ش');
      case 1:
        return new CalenderNameViewModel('Sunday', 'Su', 'یکشنبه', 'ی');
      case 2:
        return new CalenderNameViewModel('Monday', 'Mo', 'دوشنبه', 'د');
      case 3:
        return new CalenderNameViewModel('Tuesday', 'Tu', 'سه شنبه', 'س');
      case 4:
        return new CalenderNameViewModel('Wednesday', 'We', 'چهارشنبه', 'چ');
      case 5:
        return new CalenderNameViewModel('Thursday', 'Th', 'پنجشنبه', 'پ');
      case 6:
        return new CalenderNameViewModel('Friday', 'Fr', 'جمعه', 'ج');
      default:
        return new CalenderNameViewModel('Friday', 'Fr', 'جمعه', 'ج');
    }
  }

  public GetMonthName(monthNumber: number): CalenderNameViewModel {
    switch (monthNumber) {
      case 0:
        return new CalenderNameViewModel('Farvardin', 'Fa', 'فروردین', 'فر');
      case 1:
        return new CalenderNameViewModel('Ordibehesht', 'Or', 'اردیبهشت', 'ار');
      case 2:
        return new CalenderNameViewModel('Khordad', 'Kh', 'خرداد', 'خر');
      case 3:
        return new CalenderNameViewModel('Tir', 'Ti', 'تیر', 'تی');
      case 4:
        return new CalenderNameViewModel('Mordad', 'Mo', 'مرداد', 'مر');
      case 5:
        return new CalenderNameViewModel('Shahrivar', 'Sh', 'شهریور', 'شه');
      case 6:
        return new CalenderNameViewModel('Mehr', 'Me', 'مهر', 'مه');
      case 7:
        return new CalenderNameViewModel('Aban', 'Ab', 'آبان', 'آب');
      case 8:
        return new CalenderNameViewModel('Azar', 'Az', 'آذر', 'آذ');
      case 9:
        return new CalenderNameViewModel('Dey', 'De', 'دی', 'دی');
      case 10:
        return new CalenderNameViewModel('Bahman', 'Ba', 'بهمن', 'به');
      case 11:
        return new CalenderNameViewModel('Esfand', 'Es', 'اسفند', 'اس');
      default:
        return new CalenderNameViewModel('Esfand', 'Es', 'اسفند', 'اس');
    }
  }

  public GetDatePickerMonth(
    monthNumber: number,
    yearNumber: number
  ): DatePickerModel {
    var result = new DatePickerModel(
      this.GetMonthName(monthNumber-1),
      monthNumber,
      yearNumber,
      this.monthClassNames[monthNumber-1]
    );

    result.weeks = this.GetMonth(monthNumber, yearNumber);
    return result;
  }
}
